import PropTypes from "prop-types"
import { Fragment } from "react"

const FAQ = ({ faqs }) => {
  if (!faqs?.length) return null

  return faqs.map((faq, i) => (
    <Fragment key={`collection-faq-${faq.id}-${i}`}>
      <h2 className="h3 mb-8">{faq.question}</h2>
      <p className="mb-16">{faq.answer}</p>
    </Fragment>
  ))
}

FAQ.propTypes = {
  faqs: PropTypes.array,
}

export default FAQ
